import { render, staticRenderFns } from "./dialogDetachInterface.vue?vue&type=template&id=d0ac7b72&scoped=true"
import script from "./dialogDetachInterface.vue?vue&type=script&lang=js"
export * from "./dialogDetachInterface.vue?vue&type=script&lang=js"
import style0 from "./dialogDetachInterface.vue?vue&type=style&index=0&id=d0ac7b72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0ac7b72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCard,VCardText,VCol,VDialog,VRow,VSelect})
